export type LokiMarket = 'US' | 'UK';

export const fetchLokiProxy = async (skuIds: string[], market: LokiMarket = 'US'): Promise<unknown[]> => {
    const skus = Array.from(new Set(skuIds.map((sku) => sku.trim()).filter(Boolean)));
    if (skus.length === 0) return [];

    const defaultUrl = 'https://lokiproxy-ezhgftgjewccfpee.eastus-01.azurewebsites.net/api/proxy';
    const country_code = market === 'UK' ? 'GB' : 'US';
    const locale = market === 'UK' ? 'en_GB' : 'en_US';
    const response = await fetch(process.env.REACT_APP_LOKI_PROXY_URL || defaultUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ skus, country_code, locale }),
        redirect: 'follow',
    });
    if (!response.ok) throw new Error(`Loki proxy failed with status ${response.status}`);
    const variants: unknown = await response.json();
    if (!Array.isArray(variants)) throw new Error('Loki proxy returned an invalid variants response');
    return variants;
};
